"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGddFullError = exports.getGddDeleteError = exports.getGddError = void 0;
var Context_1 = require("../../Enums/Context");
var Wordings_1 = __importDefault(require("../../Constants/Wordings"));
var DateCalculation_1 = require("../Dates/DateCalculation");
var getGddError = function (gdd, options) {
    if (options === void 0) { options = { context: Context_1.Context.Basket }; }
    if (!gdd)
        return null;
    var context = options.context;
    var isSubscriptionContext = context.includes(Context_1.Context.Subscription);
    if (!gdd.timeSlot)
        return (0, exports.getGddDeleteError)(gdd, { context: context });
    if ((isSubscriptionContext && gdd.isFullForSubscription) || gdd.isFull)
        return (0, exports.getGddFullError)(gdd, { context: context });
    if (gdd.isTooLate)
        return Wordings_1.default.GROUP_DELIVERY_DAY.TOO_LATE.DEFAULT;
    if (!gdd.isNextDeliveryAvailable)
        return Wordings_1.default.GROUP_DELIVERY_DAY.NOT_AVAILABLE.DEFAULT;
    return null;
};
exports.getGddError = getGddError;
var getGddDeleteError = function (gdd, options) {
    var _a;
    if (options === void 0) { options = { context: Context_1.Context.Basket }; }
    var context = (options || {}).context;
    switch (context) {
        case Context_1.Context.Basket:
            var msg = Wordings_1.default.GROUP_DELIVERY_DAY.DELETE.CONTEXT_BASKET;
            var minimumDate = (_a = (0, DateCalculation_1.getMinimumDeliveryDate)(gdd)) === null || _a === void 0 ? void 0 : _a.toISOString();
            return minimumDate ? "".concat(msg, "<br><br> ").concat(Wordings_1.default.GROUP_DELIVERY_DAY.MINIMUM_DATE_BRIEF.replace('{minimumDate}', minimumDate)) : msg;
        default:
            return Wordings_1.default.GROUP_DELIVERY_DAY.DELETE.DEFAULT;
    }
};
exports.getGddDeleteError = getGddDeleteError;
var getGddFullError = function (gdd, options) {
    var _a;
    if (options === void 0) { options = { context: Context_1.Context.Basket }; }
    var context = (options || {}).context;
    switch (context) {
        case Context_1.Context.Basket:
            var msg = Wordings_1.default.GROUP_DELIVERY_DAY.FULL.CONTEXT_BASKET;
            var minimumDate = (_a = (0, DateCalculation_1.getMinimumDeliveryDate)(gdd)) === null || _a === void 0 ? void 0 : _a.toISOString();
            return minimumDate ? "".concat(msg, "<br><br> ").concat(Wordings_1.default.GROUP_DELIVERY_DAY.MINIMUM_DATE_BRIEF.replace('{minimumDate}', minimumDate)) : msg;
        default:
            return Wordings_1.default.GROUP_DELIVERY_DAY.FULL.DEFAULT;
    }
};
exports.getGddFullError = getGddFullError;
exports.default = { getGddError: exports.getGddError, getGddDeleteError: exports.getGddDeleteError, getGddFullError: exports.getGddFullError };
//# sourceMappingURL=GroupDeliveryDayErrors.js.map